<div class="property-container" style="background: #000;">
  <div *ngIf="!isLoading">
    <div class="flex justify-between align-center  ">
      <div fxLayout="row" fxLayoutAlign="start center" style="margin-bottom:18px">
        <ng-container *ngIf="!isFiltered">
          Total {{properties.length}} Properties
        </ng-container>
        <ng-container *ngIf="isFiltered">
          {{dataSourceCount}} Result
        </ng-container>
      </div>
      <!-- <button mat-button class="add-property-button" (click)="openAddDialog()">
          <mat-icon style="margin-bottom: 2px; width: 16px; height: 16px; font-size: 16px; margin-right: 4px">
              add
          </mat-icon>
          Add Property
      </button> -->
      <div class="flex align-center">
        <button mat-button class="filter-button isFiltered" style="margin-right: 10px;" *ngIf="isFiltered"
                (click)="clearFilterData()">
          Clear Filter
        </button>
        <button mat-button class="filter-button isFiltered" *ngIf="isFiltered" [matMenuTriggerFor]="filterMenu">
          <img class="png-icon" src="./assets/images/black/filter.png">
          Filter
        </button>
        <button mat-button class="filter-button" *ngIf="!isFiltered" [matMenuTriggerFor]="filterMenu">
          <img class="png-icon" src="./assets/images/black/filter.png">
          Filter
        </button>
        <mat-menu #filterMenu="matMenu" xPosition="before" class="filter-menu">
          <div fxLayout="column" (click)="stopPropagation($event)">
            <div fxLayout="row" fxLayoutAlign="space-between flex-end" class="filter-title">
              <!-- <div fxLayout="row" fxLayoutAlign="space-between center"> -->
              <div>Filter</div>
              <a class="clear-filter" (click)="clearFilterData()">Clear Filter</a>
              <!-- </div> -->
              <!-- <button mat-icon-button mat-dialog-close>
                  <mat-icon style="color: #DEDEDE;">close</mat-icon>
              </button> -->
            </div>
            <div class="menu-item flex justify-between">
              <div style="width: 45%;">
                <div class="item-title">Bedrooms</div>
                <div class="item-content" fxLayout="row" fxLayoutGap="15px">
                  <mat-form-field appearance="outline">
                    <mat-label>Min Bedrooms</mat-label>
                    <mat-select [(value)]="selectedMinBedrooms">
                      <mat-option *ngFor="let item of filterParams.bedRoom" [value]="item.value">
                        {{item.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Max Bedrooms</mat-label>
                    <mat-select [(value)]="selectedMaxBedrooms">
                      <mat-option *ngFor="let item of filterParams.bedRoom" [value]="item.value">
                        {{item.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <!-- <mat-checkbox *ngFor="let item of filterParams.bedRoom" [(ngModel)]="item.isChecked"
                      (change)="checkFilterParams(filterParams.bedRoom, item)">
                      {{item.label}}
                  </mat-checkbox> -->
                </div>
              </div>
              <div style="width: 45%;">
                <div class="item-title">Bathrooms</div>
                <div class="item-content" fxLayout="row" fxLayoutGap="15px">
                  <mat-form-field appearance="outline">
                    <mat-label>Min Bathrooms</mat-label>
                    <mat-select [(value)]="selectedMinBathrooms">
                      <mat-option *ngFor="let item of filterParams.bathRoom" [value]="item.value">
                        {{item.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Max Bathrooms</mat-label>
                    <mat-select [(value)]="selectedMaxBathrooms">
                      <mat-option *ngFor="let item of filterParams.bathRoom" [value]="item.value">
                        {{item.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <!-- <mat-checkbox *ngFor="let item of filterParams.bathRoom" [(ngModel)]="item.isChecked"
                      (change)="checkFilterParams(filterParams.bathRoom, item)">
                      {{item.label}}
                  </mat-checkbox> -->
                </div>
              </div>

            </div>
            <div class="menu-item flex justify-between">
              <div style="width: 45%;">
                <div class="item-title">Car spaces</div>
                <div class="item-content" fxLayout="row" fxLayoutGap="15px">
                  <mat-form-field appearance="outline">
                    <mat-label>Min Car space</mat-label>
                    <mat-select [(value)]="selectedMinCarspace">
                      <mat-option *ngFor="let item of filterParams.carParking"
                                  [value]="item.value">
                        {{item.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Max Car space</mat-label>
                    <mat-select [(value)]="selectedMaxCarspace">
                      <mat-option *ngFor="let item of filterParams.carParking"
                                  [value]="item.value">
                        {{item.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <!-- <mat-checkbox *ngFor="let item of filterParams.carParking" [(ngModel)]="item.isChecked"
                      (change)="checkFilterParams(filterParams.carParking, item)">
                      {{item.label}}
                  </mat-checkbox> -->
                </div>
              </div>
              <div style="width: 45%;">
                <div class="item-title">Price</div>
                <div class="item-content" fxLayout="row" fxLayoutGap="15px">
                  <mat-form-field appearance="outline">
                    <mat-label>Min Price Range</mat-label>
                    <mat-select [(value)]="selectedMinPriceRange">
                      <mat-option *ngFor="let item of filterParams.priceRange"
                                  [value]="item.value">
                        {{item.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Max Price Range</mat-label>
                    <mat-select [(value)]="selectedMaxPriceRange">
                      <mat-option *ngFor="let item of filterParams.priceRange"
                                  [value]="item.value">
                        {{item.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <!-- <mat-range-slider [style.flex-grow]="0" #matRangeSlider class="price-range"
                      [disabled]="false" [invert]="false" [max]="maxPrice" [min]="minPrice"
                      (input)="filterParams.priceRange = $event.value" [step]="1" [thumbLabel]="false"
                      [tickInterval]="0" [vertical]="false">
                  </mat-range-slider>
                  <div style="display: flex; justify-content: space-between;">
                      <span>{{filterParams.priceRange.min}}</span>
                      <span>{{filterParams.priceRange.max}}</span>
                  </div> -->
                </div>
              </div>

            </div>
            <!-- <div class="menu-item">
                <div class="item-title">Price</div>
                <div class="item-content">
                    <mat-range-slider [style.flex-grow]="0" #matRangeSlider class="price-range"
                        [disabled]="false" [invert]="false" [max]="maxPrice" [min]="minPrice"
                        (input)="filterParams.priceRange = $event.value" [step]="1" [thumbLabel]="false"
                        [tickInterval]="0" [vertical]="false">
                    </mat-range-slider>
                    <div style="display: flex; justify-content: space-between;">
                        <span>{{filterParams.priceRange.min}}</span>
                        <span>{{filterParams.priceRange.max}}</span>
                    </div>
                </div>
            </div> -->
            <div class="menu-item">
              <div class="item-title">Aspect</div>
              <div class="item-content" fxLayout="row wrap" fxLayoutAlign="start" style="height: 120px;">
                <mat-checkbox *ngFor="let item of filterParams.aspect" [(ngModel)]="item.isChecked">
                  {{item.label}}</mat-checkbox>
              </div>
            </div>
            <div class="menu-item">
              <div class="item-title">Status</div>
              <div class="item-content" fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="start"
                   style="height: 80px;">
                <mat-checkbox *ngFor="let item of filterParams.status" [(ngModel)]="item.isChecked">
                  {{item.label}}</mat-checkbox>
              </div>
            </div>
          </div>
          <div style="padding:0 32px 32px;">
            <button (click)="filterData()" mat-flat-button
                    style="width:100%;background: #161616;border-radius: 8px;color:#DEDEDE;border: 1px solid #DEDEDE;height: 52px;">
              Apply
              Filters
            </button>
          </div>
        </mat-menu>

        <!-- <mat-select [(value)]="selected" class="sort-select ml_15">
            <mat-option *ngFor="let selectUnit of selectList" [value]="selectUnit">
                {{ selectUnit }}
            </mat-option>
        </mat-select> -->


        <div class="switch-button-group ml_20" fxLayout="row" fxLayoutAlign="center center">
          <div class="block_box" fxLayout="row" fxLayoutAlign="center center"
               [ngClass]="{'active':  mode == 'list'}" (click)="changeMode('list')">
            <img src="./assets/images/black/list_{{mode}}.png" class="list_image">
          </div>
          <div class="block_box" fxLayout="row" fxLayoutAlign="center center"
               [ngClass]="{'active':  mode == 'grid'}" (click)="changeMode('grid')">
            <img src="./assets/images/black/block_{{mode}}.png" class="list_image">
          </div>
        </div>

      </div>
    </div>
    <!-- <div style="height: 100px;background:#000;z-index:999;"></div> -->

    <!-- <div fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom:16px">
        <div fxLayout="row" fxLayoutGap="12px">
            <input (keyup.enter)="filterData()" [(ngModel)]="keywords" class="input search-input" type="text"
                placeholder="Search Property Name" />

        </div>
        <div fxLayout="row" fxLayoutGap="12px">
            <button mat-button class="add-property-button" (click)="openAddDialog()">
                <mat-icon style="margin-bottom: 2px; width: 16px; height: 16px; font-size: 16px; margin-right: 4px">
                    add
                </mat-icon>
                Add Property
            </button>
        </div>
    </div> -->

    <!-- <div fxLayout="row" fxLayoutGap="24px" class="property-status" style="margin-bottom:24px" *ngIf="mode == 'matrix'">
        <app-property-status [status]="0"></app-property-status>
        <app-property-status [status]="1"></app-property-status>
        <app-property-status [status]="3"></app-property-status>
        <app-property-status [status]="4"></app-property-status>
        <app-property-status [status]="6"></app-property-status>
    </div> -->
    <div fxLayout="row" fxLayoutAlign="space-between" class="properties-content">
      <mat-tab-group mat-align-tabs="start" style="width:100%" (selectedTabChange)="tabChanged($event)" #childTabs
                     [(selectedIndex)]="this.tabService.propertyIndex">
        <mat-tab *ngFor="let building of project.buildings; let i = index">
          <ng-template mat-tab-label>
            {{ building.name ? building.name : 'Tower ' + (i + 1) }}
            <span class="tab-count">{{dataSource.get(building.id).data.length}}</span>
          </ng-template>
          <div style="height: 60px;background:#000;"></div>
          <div *ngIf="dataSource.get(building.id).data.length > 0 && mode == 'grid'" class="properties-matrix"
               style="margin-top:24px"
               [ngStyle]="{'min-height': (windowHeight - 464 > 300 ? windowHeight - 464 : 300)+'px'}">

            <ng-container *ngIf="project.projectTypes[0].id === 3">
              <div *ngFor="let level of dataSource.get(building.id).levelSet" style="margin-bottom: 5px;">
                <div style="min-width: 112px; margin-right: 5px;" class="fz_18 fc_DEDEDE mb_20">
                  Floor {{transformLevel(level)}}</div>
                <div fxLayout="row wrap" fxLayoutGap="24px">
                  <div *ngFor="let property of getPropertiesByLevel(building.id, level); let i = index"
                       class="matrix-box"
                       [ngClass]="{'matrix-box-checked': property.isChecked === true}"
                       fxLayout="column" fxLayoutAlign="start" (click)="openDetailDialog(property)">
                    <div class="flex align-center">
                      <div class="fz_24 fc_DEDEDE">{{property.unitNum}}</div>
                      <div
                        class="ml_15 fz_14  {{getStatusLabel(property.status)}} flex align-center">
                        <div class="dot {{getStatusLabel(property.status)}}BG"></div>
                        {{getStatusLabel(property.status) | titlecase}}
                      </div>
                    </div>
                    <div class="mt_15 fz_14" style="color: rgba(222, 222, 222, 0.4);">
                      {{property.bedRoom}} Bed /
                      {{property.bathRoom}} Bath /
                      {{property.carParking}} Car Park
                    </div>
                    <div style="position: absolute;bottom: 16px;right: 16px;" class="fz_16 fw_600">
                      {{property.price |
                      currency: '':'symbol':'1.0'}}</div>
                    <!-- <div class="matrix-content">
                        <span (click)="openDetailDialog(property)"
                            class="name">{{property.unitNum}}</span>
                        <span (click)="openDetailDialog(property)"
                            class="show-on-hover">{{property.bedRoom}}B /
                            {{property.bathRoom}}B /
                            {{property.carParking}}C
                        </span>
                        <span (click)="openDetailDialog(property)"
                            class="show-on-hover">{{property.price | currency:
                            '':'symbol':'1.0'}}</span>
                        <span class="hide-on-hover">{{getStatusLabel(property.status) |
                            titlecase}}</span>
                    </div> -->
                    <mat-checkbox [(ngModel)]="property.isChecked" *ngIf="property.status != 6"
                                  (change)="selectedPropertiesChange(building.id,property.id)"
                                  (click)="stopPropagation($event);"
                                  style="position: absolute; top:16px; right: 16px; width: 20px; height: 20px">
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="[1,2].includes(project.projectTypes[0].id)">
              <div fxLayout="row wrap" fxLayoutGap="24px" style="margin-bottom: 5px;margin-top: 24px;">
                <div *ngFor="let property of dataSource.get(building.id).data; let i = index"
                     (click)="openDetailDialog(property)"
                     class="matrix-box show-on-hover {{getStatusLabel(property.status)}}"
                     [ngClass]="{'matrix-box-checked': property.isChecked === true}" fxLayout="column"
                     fxLayoutAlign="start start">

                  <div class="flex align-center">
                    <div class="fz_24 fc_DEDEDE">{{property.unitNum}}</div>
                    <div class="ml_15 fz_14  {{getStatusLabel(property.status)}} flex align-center">
                      <div class="dot {{getStatusLabel(property.status)}}BG"></div>
                      {{getStatusLabel(property.status) | titlecase}}
                    </div>
                  </div>
                  <div class="mt_15 fz_14" style="color: rgba(222, 222, 222, 0.4);">
                    {{property.bedRoom}} Bed /
                    {{property.bathRoom}} Bath /
                    {{property.carParking}} Car Park
                  </div>
                  <div style="position: absolute;bottom: 16px;right: 16px;" class="fz_16 fw_600">
                    {{property.price |
                    currency: '':'symbol':'1.0'}}</div>

                  <mat-checkbox [(ngModel)]="property.isChecked"
                                (change)="selectedPropertiesChange(building.id,property.id)"
                                (click)="stopPropagation($event);" class="show-on-hover"
                                style="position: absolute; top: 5px; right: 5px; width: 16px; height: 16px">
                  </mat-checkbox>
                </div>
              </div>
            </ng-container>


          </div>
          <div class="properties-table"
               *ngIf="dataSource.get(building.id).tableData.length > 0 && mode == 'list'"
               [ngStyle]="{'min-height': (windowHeight - 464 > 300 ? windowHeight - 464 : 300)+'px'}">
            <table mat-table [dataSource]="dataSource.get(building.id).tableData" style="width: 100%;">
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox [color]="'primary'"
                                (change)="$event ? masterToggle(building.id) : null"
                                [checked]="dataSource.get(building.id).selection.hasValue() && isAllSelected(building.id)"
                                [indeterminate]="dataSource.get(building.id).selection.hasValue() && !isAllSelected(building.id)"
                                [aria-label]="checkboxLabel(building.id)">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox *ngIf="row.status != 6" [color]="'primary'"
                                [(ngModel)]="row.isChecked" (click)="stopPropagation($event);"
                                (change)="$event ? dataSource.get(building.id).selection.toggle(row) : null"
                                [checked]="dataSource.get(building.id).selection.isSelected(row)"
                                (change)="selectedPropertiesChange(building.id,row.id)"
                                [aria-label]="checkboxLabel(building.id, row)">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="unit">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">Property</div>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{element.unitNum}}
                </td>
              </ng-container>
              <ng-container matColumnDef="floor">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">Floor</div>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{transformLevel(element.level)}}
                </td>
              </ng-container>
              <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">B/B/C</div>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{element.bedRoom}}/{{element.bathRoom}}/{{element.carParking}}
                </td>
              </ng-container>

              <ng-container matColumnDef="aspect">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">Aspect</div>
                </th>
                <td mat-cell *matCellDef="let element">
                                    <span style="cursor: pointer">
                                        <ng-container *ngIf="element.aspect">
                                            {{constants.PROJECT_ASOECT_NAME_MAP[element.aspect] ?
                                          constants.PROJECT_ASOECT_NAME_MAP[element.aspect].name : '-'}}
                                        </ng-container>
                                        <ng-container *ngIf="!element.aspect">
                                            -
                                        </ng-container>
                                    </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="internalArea">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">Internal Area m²</div>
                </th>
                <td mat-cell *matCellDef="let element">
                  <span style="cursor: pointer">{{element.internalArea}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="externalArea 1">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">External Area 1 m²</div>
                </th>
                <td mat-cell *matCellDef="let element">
                                    <span
                                      style="cursor: pointer">{{(element.externalAreas?.externalArea1 ?
                                      element.externalAreas?.externalArea1 :
                                      0) | number: '1.2-2'}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="externalArea 2">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">External Area 2 m²</div>
                </th>
                <td mat-cell *matCellDef="let element">
                                    <span
                                      style="cursor: pointer">{{(element.externalAreas?.externalArea2 ?
                                      element.externalAreas?.externalArea2 :
                                      0 | number: '1.2-2')}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">Price (AUD)</div>
                </th>
                <td mat-cell *matCellDef="let element">
                                    <span style="cursor: pointer">{{element.price | currency:
                                      '':'symbol':'1.0-0'}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="pricePerArea">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">Price per area AUD/m²</div>
                </th>
                <td mat-cell *matCellDef="let element">
                                    <span style="cursor: pointer">{{element.price / element.totalArea | currency:
                                      '':'symbol':'1.0-0'}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">Status</div>
                </th>
                <td mat-cell *matCellDef="let element" style="text-align: center;"
                    class="{{getStatusLabel(element.status)}}">
                                    <span style="cursor: pointer">
                                        <app-property-status [status]="element.status"></app-property-status>
                                    </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="floorPlan">

                <th mat-header-cell *matHeaderCellDef>
                  <div class="properties-table-title">Floorplans</div>
                </th>
                <td mat-cell *matCellDef="let element" (click)="stopPropagation($event);">
                  <div fxLayout="row" fxLayoutAlign="center ">
                    <!-- <ng-container *ngIf="element.floorPlan">
                        <span style="color: #3C50E0; cursor: pointer;"
                            (click)="openFloorPlan(element.floorPlan, element.unit)">
                            <img src="./assets/images/floorplan-gray.png"
                                style="width: 16px; height: 16px">
                        </span>
                    </ng-container>
                    <ng-container *ngIf="!element.floorPlan">
                        <span>-</span>
                    </ng-container> -->
                    <button mat-button class="edit-button"
                            (click)="editProperty(building, element)">
                      Edit
                    </button>
                    <!-- <mat-icon style="width:12px;height:12px;font-size:12px"
                        (click)="editProperty(building, element)">edit
                    </mat-icon> -->
                  </div>

                </td>

              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
              <tr (click)="openDetailDialog(row)" mat-row
                  *matRowDef="let row; columns: displayedColumns;">
              </tr>
            </table>
          </div>
          <ng-container *ngIf="dataSource.get(building.id).data.length === 0 && !isFiltered">
            <div
              style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0;min-height: 300px;"
              [ngStyle]="{height: (windowHeight - 520)+'px'}">
              <p style="margin:4px;color: #DEDEDE;font-size: 18px;font-weight: 600;">No property found</p>
              <p style="margin:4px;color: #DEDEDE;opacity: 0.7;">You have not added any property in this
                building</p>
              <button mat-flat-button
                      style="margin-top:12px;background: #000;border-radius: 4px;color:#DEDEDE;border: 1px solid #DEDEDE;"
                      (click)="openAddDialog()">Add property
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="dataSource.get(building.id).data.length === 0 && isFiltered">
            <div
              style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0;min-height: 300px;"
              [ngStyle]="{height: (windowHeight - 520)+'px'}">
              <p style="margin:4px;color: #dedede;font-size: 18px;font-weight: 600;">No matching items
                found</p>
              <p style="margin:4px;color: #dedede;opacity: 0.7;">Try adjusting your search or filter to
                find
                what are you looking for.</p>
            </div>
          </ng-container>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div class="status-bar" fxLayout="row" *ngIf="showStatusBar" fxLayoutAlign="space-between center">
      <div style="font-weight: 500;font-size: 16px;">{{selectedProperties.length}} properties selected</div>
      <div fxLayout="row">
        <mat-menu #statusMenu="matMenu" yPosition="above" class="status-menu operate_box3">
          <button mat-menu-item (click)="openUpdateStatusDialog(0)">
            <app-property-status [status]="0"></app-property-status>
          </button>
          <button mat-menu-item (click)="openUpdateStatusDialog(1)">
            <app-property-status [status]="1"></app-property-status>
          </button>
          <button mat-menu-item (click)="openUpdateStatusDialog(3)">
            <app-property-status [status]="3"></app-property-status>
          </button>
          <button mat-menu-item (click)="openUpdateStatusDialog(4)">
            <app-property-status [status]="4"></app-property-status>
          </button>
          <button mat-menu-item (click)="openUpdateStatusDialog(6)">
            <app-property-status [status]="6"></app-property-status>
          </button>
          <div class="target"></div>
        </mat-menu>
        <button mat-flat-button class="change-status-button" style="margin-right: 20px" (click)="allocate()">
          Allocate
        </button>
        <button mat-flat-button [matMenuTriggerFor]="statusMenu" class="change-status-button">Status</button>
        <button mat-button class="close-button">
          <mat-icon fontSet="material-icons-round" (click)="closeStatusBar()">close</mat-icon>
        </button>
      </div>
    </div>

  </div>

  <div *ngIf="isLoading">
    <app-loading></app-loading>
  </div>
</div>
